export default "__VITE_ASSET__fX8XhXfk__"